import { useState } from "react";
import { ErrorDetailContainer } from "../../../api/config";
import {
    RegistrationRequestInput,
    RegistrationService,
} from "../../../api/psc";

// const fakePostData = (registrationInput: RegistrationRequestInput) =>
//     new Promise<any>((res, rej) => {
//         setTimeout(() => {
//             res("sdfsdf");
//         }, 2000);
//     });

export const usePostRegistrationData = () => {
    const [data, setData] = useState<string>(null);
    const [error, setError] = useState<ErrorDetailContainer>(null);
    const [inProgress, setInProgress] = useState<boolean>(false);

    const postRegistrationData = (
        registrationInput: RegistrationRequestInput
    ) =>
        new Promise<string>((res, rej) => {
            const asyncFunctionToPost = async () => {
                setInProgress(true);
                try {
                    // const result = await fakePostData(registrationInput);
                    const result =
                        await RegistrationService.createRegistrationRequest(
                            "1",
                            registrationInput
                        );
                    setData(result);
                    setInProgress(false);
                    return res(result);
                } catch (error) {
                    setError(error);
                    setInProgress(false);
                    return rej(error);
                }
            };
            asyncFunctionToPost();
        });

    return { data, error, inProgress, postRegistrationData };
};
